import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  { n: "01", title: "Claude Code", text: "KI-Entwicklungspartner" },
  { n: "02", title: "Jeder Commit markiert", text: "[ai-assisted]" },
  { n: "03", title: "Externer Code Review (DigitalMasters)", text: "300.000 Zeilen geprüft · 1,3 % Anpassungen" },
  { n: "04", title: "Governance", text: "Spike → Prototyp → Produktion" },
];

export function Slide05KIEntwicklung(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Wie wir bauen</div>
        <h1 className="deck-title rise rise-2">
          KI-gestützte <br />
          <span className="accent">Entwicklung</span>
        </h1>
        <p className="deck-sub rise rise-3">Transparent, geprüft, dokumentiert.</p>
      </header>

      <div className="deck-cols4">
        {TILES.map((t, i) => (
          <div key={t.n} className={`col-card rise rise-${(i % 3) + 4}`}>
            <div className="num">{t.n}</div>
            <h4>{t.title}</h4>
            <p>{t.text}</p>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>Keine Blackbox – transparenter Prozess mit Sicherheitsnetz.</span>
      </footer>
    </div>
  );
}
